<template>
  <div>
    <!--new main-->
    <!--이미지슬라이드-->
    <!-- <div class="mainsection-new-banr" v-if="data.mainBanrList && data.mainBanrList.length > 0"> -->
    <div class="mainsection-new-banr">
        <div class="inner">
            <swiper class="swiper" :options="swiperOption">
                <!-- <swiper-slide v-for="(item, idx) in data.mainBanrList" :key="idx">
                    <img :src="'/api/main/bnr/image?bannerSeq='+item.bannerSeq" :alt="item.bannerNm"/>
                </swiper-slide> -->
                <swiper-slide>
                    <img src="/images/greatpro_main01_onboard.jpg" alt="금융 IT 프리랜서를 위한 대한민국 최초 얼라이언스 플랫폼, 그레이트프로 – 지금 이륙합니다"/>
                </swiper-slide>
                <swiper-slide>
                    <img src="/images/greatpro_main02_whale.jpg" alt="금융 IT 업계를 이끄는 프리랜서 전문가를 위한 커리어 파트너, 그레이트프로"/>
                </swiper-slide>
                <swiper-slide>
                    <img src="/images/greatpro_main03_astro.jpg" alt="성과 중심으로 진짜 실력자를 연결하는 금융 IT 프리랜서 플랫폼, GreatPro"/>
                </swiper-slide>
                <swiper-slide>
                    <img src="/images/greatpro_main04_skydive.jpg" alt="단순 매칭이 아닌 가치를 연결하는 금융 IT 얼라이언스 플랫폼, 그레이트프로"/>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
    </div>

    <!--그레이트프로 메인슬로건-->
    <div class="mainsection-greatpro-txt">
        <div class="inner">
            <div class="tit">
                대한민국 최초의 초정예 플랫폼입니다. <br />
                금융 IT 얼라이언스 플랫폼, 그레이트 프로
            </div>
            <div class="count">
                <div>
                    100명 <br />
                    <span>
                        초정예 금융IT 프로 얼라이언스<br />
                        회원 수
                    </span>
                </div>
                <div>
                    17개 <br />
                    <span>
                        금융 그룹 얼라이언스<br />
                        고객 수
                    </span>
                </div>
                <div>
                    24건 <br />
                    <span>
                        대형 금융IT 프로젝트<br />
                        연간 의뢰 수
                    </span>
                </div>
                <div>
                    100% <br />
                    <span>
                        금융IT 프로젝트 얼라이언스<br />
                        만족지수
                    </span>
                </div>
            </div>
        </div>        
    </div>

    <!--메인-동영상 슬라이드-->
    <div class="mainsection-movie">
        <div class="inner">
            <video :src="playVideo" type="video/mp4" autoplay playsinline muted @ended="endVideo()" />
        </div>
    </div>

    <!--그레이트프로 프로젝트-->
    <div class="mainsection-great-pj" v-if="(data.recomendProjectList && data.recomendProjectList.length > 0) && mberDivCd !='22'">
        <div class="inner" >
            <div class="tit">지금 뜨는 프로젝트, IT 그레이트 프로를 기다립니다.</div>
            <div class="pj-img" v-for="(item, idx) in data.recomendProjectList" :key="idx" @click="clickProjectInfo(item)">
                <div class="txt-box">
                    <div class="pj-txt">
                        <span>{{ item.projectNm }}</span>
                    </div>
                </div>
                <!-- <ImageComp :src="'/api/main/bnr/recmendProjectImg?recmendProjectSeq='+item.recmendProjectSeq" alt="추천프로젝트 배너이미지" /> -->
                <ImageComp :src="'/api/main/bnr/recmendProjectImg?recmendProjectSeq='+item.recmendProjectSeq" :alt= "item.projectNm"  />
            </div>
        </div>
    </div>

    <!--이슈 프로젝트-->
    <div class="mainsection-issue" v-if="data.newsInfo">        
        <div class="inner">  
            <div class="tit">이슈 프로젝트</div>          
            <div class="box">
                <ImageComp :src="'/api/main/bnr/newsInfoImg?attaFileSeq='+data.newsInfo.attaFileSeq" alt="그레이트프로 이슈 프로젝트"/>
                <div class="content">
                    <div class="title">{{ data.newsInfo.exposureNewsTitle}}</div>
                    <div class="subtxt">{{ data.newsInfo.exposureNewsCont}}
                        <span @click="goNoticeDetail(data.newsInfo.newsCenterSeq)" >더보기</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--그레이트 프로가 되는길-->
    <div class="mainsection-itpro">
        <div class="inner">
            <div class="tit">IT 그레이트 프로가 되는 길</div>
            <div class="box">
                <img src="/images/great-pro-img.png" alt="그레이트 아카데미">
                <div class="content">
                    <div class="title">
                        We Are Great Pro! <br />
                        ‘금융 IT 무료 부트캠프’의 새로운 세계로 들어오세요.
                    </div>
                    <div class="subtxt">
                        현장에서 즉시 활용 가능한 IT 프로 양성!<br />
                        국내 금융권 IT 개발 현장과 유사한 환경에서<br />
                        금융 IT 현장 중심의 이론교육과 실습까지,<br />
                        엄격하게 선발된 소수 초정예 교육입니다.<br />
                        금융 IT의 최고 능력과 현장 통찰력을 체계적으로<br />
                        높일 수 있는 기회입니다.
                        <span @click="goPage('SUB001M01')">바로 등록하기</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--Why Great Pro-->
    <div class="mainsection-why-great">
        <div class="inner">
            <div class="why">
                왜, <br />
                금융IT 프로 <br />
                얼라이언스 플랫폼, <br />
                그레이트 프로일까?
            </div>
            <div class="answer">
                <div class="answer-tit">
                    그레이트 프로는 <br />
                    대한민국 금융IT 인재 중에서도 <br />
                    소수의 초정예 프로만을 위한 <br />
                    프로 얼라이언스 플랫폼입니다.
                </div>
                <div class="point">
                    1. 단순 매칭이 아니라 프로 얼라이언스
                    <span>
                        그레이트프로는 단순한 일자리 매칭 하나로 끝나지 않습니다. <br />
                        커리어 관리, 프로젝트 매칭, 업계 최고 수준의 보수, <br />
                        프로젝트 사후 서비스까지 <br /> 
                        최정예 프로의 커리어와 퀄리티 프로젝트의 가치 있는 연합, <br />
                        프로 얼라이언스 서비스를 제공합니다.
                    </span>
                </div>
                <div class="point">
                    2. 프로를 위한 토탈 커리어 케어 서비스
                    <span>
                        그레이트프로에 이력서를 등록하시는 순간부터<br />
                        프로 여러분의 능력 커리어, 계약 &amp; 보수 커리어 관리를 받을 수 있습니다. <br />
                        2대 보험 등을 포함한 다양한 복지 서비스, 지속적인 교육 프로그램 혜택은 물론 <br />
                        향후 프로를 위한 다양한 건강 및 여가 케어 서비스를 실시할 예정입니다.
                    </span>
                </div>
                <div class="point">
                    3. 그레이트프로 라운지 무료 이용 서비스
                    <span>
                        프리랜서의 편리한 업무를 최대한 보장하기 위한  <br />
                        혁신적 개념의 프리 오피스 공간, 그레이트프로 라운지를  <br />
                        언제든지 자유롭게 이용할 수 있습니다. <br /> 
                        또 국내는 물론 해외 주요 도시의 제휴 공유 오피스를 이용할 경우 <br />
                        그레이트프로 회원만의 파격적인 할인가 혜택을 누릴 수 있습니다.
                    </span>
                </div>
                <div class="ps">※ 그레이트프로 라운지 서비스는 2025년 하반기 오픈 예정입니다.</div>
            </div>
        </div>
    </div>

    <div class="mainsection-great-member">
        <div class="inner">
            <div class="tit">
                그레이트 프로 회원 혜택
            </div>
            <div class="tit-txt">
                프로젝트 참여 중이거나 <br />
                프로젝트를 완성한 <br />
                그레이트 프로의 IT 프로들을 위한 <br />
                비즈니스 지원부터 커뮤니티 활동 지원까지 <br />
                다양한 혜택을 만나보세요.
            </div>
        </div>
        <div class="inner-2nd">
            <div>
                <div class="benefit01">
                    비즈니스 <br >
                    지원
                </div>
                <div class="benefit-txt">
                    <ul>
                        세무 및 법무 지원
                        <ol>
                            <li>세무대행 할인 서비스 (일반 IT 프로 회원 5만원 할인)</li>
                            <li>법률 상담 서비스 (계약서 검토 및 작성, 분쟁 상담)</li>
                        </ol>
                    </ul>
                </div>
            </div>
            <div>
                <div class="benefit02">
                    라이프케어 <br >
                    지원
                </div>
                <div class="benefit-txt">
                    <ul>
                        건강 및 복지 지원
                        <ol>
                            <li>건강검진 지원 (제휴병원 할인 또는 10만원 지원)</li>
                            <li>무료 심리상담 서비스 (프로젝트당 1회 무료, 번아웃 &middot; 스트레스 관리)</li>
                            <li>2대 보험 보장 (고용보험, 산재보험 지원)</li>
                            <li>그레이트 인센티브 : 프로필 완성 + 성공 보상금 (일반 50만원, 스페셜 100만원)</li>
                        </ol>
                    </ul>
                </div>
            </div>
            <div>
                <div class="benefit03">
                    네트워킹 <br >
                    지원
                </div>
                <div class="benefit-txt">
                    <ul>
                        성공을 위한 네트워킹 지원
                        <ol>
                            <li>IT 프로의 성공을 위한 정기 모임 무료 참석권 (연 4회)</li>
                            <li>'그레이트 프로 멘토링 프로그램' 참여</li>
                            <li>연말 '그레이트 프로 어워드' 선정자격 및 시상식 참여</li>
                        </ol>
                    </ul>
                </div>
            </div>
            <div>
                <div class="benefit04">
                    스페셜 <br >
                    IT 프로 우대
                </div>
                <div class="benefit-txt">
                    <ul>
                        업계 최고 수준 특별 지원
                        <ol>
                            <li>프로젝트 우선 매칭</li>
                            <li>1:1 전담 매니저 배정</li>
                            <li>세무대행 10만원 할인 서비스</li>
                            <li>무료 심리상담 : 프로젝트 당 1회, 연 1회 추가</li>
                        </ol>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!--그레이트프로 블로그-->
    <div class="mainsection-blog" v-if="data.blogList && data.blogList.length > 0">
        <div class="inner">
            <div class="tit">
                요즘 알아두면 좋은 <br />
                IT 뉴스 &amp; 이슈들, <br />
                그레이트 프로 <br />
                블로그
            </div>
            <div class="blog-box">
                <div class="box" v-for="(item, idx) in data.blogList" :key="idx" @click="goPage(item.blogLinkUrl,'01')">
                     <ImageComp style="cursor: pointer;" :src="'/api/main/bnr/blogImg?blogSeq='+item.blogSeq" :alt="item.blogTitle" defaultSrc="/images/blog-img-02.png"/>
                    <div>
                        {{ item.blogTitle }}
                        <span>{{ item.blogDtlDesc }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--고객사-->
    <div class="mainsection-client">
        <div class="inner">
            <div class="tit">
                그레이트 프로는 대한민국 탑티어 고객사와 <br />
                프로젝트 성공 경험을 공유하고 있습니다.
            </div>
            <img src="/images/great-pro-client.png" alt="그레이트프로 협력사">
        </div>
    </div>
    <!--new main 끝--> 
  </div>
  
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { mainMeta } from '@/utils/meta';


export default {
    metaInfo : mainMeta,
    components: {
        Swiper, SwiperSlide
    },
   
	data() {
		return {
            now: new Date().format("yyyyMMdd"),
		    data : {},
            partnerSlide : [
                { img: '/images/partner.png', desc:'행정안정부, KB국민은행, KB국민카드, KB저축은행, KEB하나은행, KAKAO, 신한은행, 우리은행, NH농협, 롯데카드, 우정사업본부, 한국주택금융공사, 미소금융중앙재단, 웰컴저축은행, SGI서울보증, KoFC한국정책금융공사, KORES한국광물자원공사, 메리츠종금증권, 한국투자 밸류자산운용' },
            ],

            mberDivCd : '',

            videoIdx : 0,
            videoList : ['greatpro_brand01_dolphin.mp4', 'greatpro_brand02_skydive.mp4', 'greatpro_brand03_forest.mp4'],
            playVideo : '/video/greatpro_brand01_dolphin.mp4',

            swiperOption: {
                slidesPerView: 1,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false
                },
            },
		}
	},
	beforeMount(){
        this.mberDivCd = this.$store.state.userInfo.mberDivCd;

        this.$.httpPost("/api/main/")
            .then(res => {
                this.data = res.data || {};
            }).catch(this.$.httpErrorCommon);
	},
    created() {

    },
	mounted(){ 
        // this.$.httpPost("/api/main/")
        //     .then(res => {
        //         this.data = res.data || {};
        //     }).catch(this.$.httpErrorCommon);

        // IT프로일 경우, 추천인 입력 팝업
        if(this.mberDivCd == '11'){
            setTimeout(() => {
                if(this.$route.query.userDstic == '') {
                    this.recmmRegiPup();
                }
            }, 100);
        }
        
        // 오늘하루보지않기
        // if(this.$store.state.hoverPopupDay.date == new Date().format('yyyyMMdd')) {
        //     return;
        // } else {
        //     this.$.popup('/man/MAN000P01')
		// 		.then(() => {					
		// 		})
        // }
	},
	methods: {
        // 추천 프로젝트 상세
		clickProjectInfo(item) {
			if(this.$store.state.userInfo.mberSeq) {
                var pageId = 'PRJ101M02';
                if(this.mberDivCd == '31') pageId = 'PRJ405M03';
                
				this.$router.push({name : pageId, query : {projectSeq : item.projectSeq}});
			} else {
                pageId = 'PRJ101M03'
				// this.$.popup('/tec/prj/PRJ101P03')
				// 	.then(res => {
				// 		if(res) {
				// 			// 회원가입 화면으로 이동
				// 			this.$router.push({name : 'MEM003M01'});
				// 		}
				// 	});
			}

            this.$router.push({name : pageId, query : {projectSeq : item.projectSeq}});
        },

       // 공지사항 상세
        goNoticeDetail(newsCenterSeq) {
            this.$router.push({name: 'BBS003M02', query:{no:newsCenterSeq}});
        },

        goPage(url,viewDiv){
            if(viewDiv == '01') window.open(url, '_blank')
            else this.$router.push({name: url});
            
        },

        endVideo(){
            if(this.videoIdx == (this.videoList.length-1)){
                this.videoIdx = 0;
            }else{
                this.videoIdx++;
            }
            this.playVideo = '/video/' + this.videoList[this.videoIdx];
		},

        // 추천인 입력 팝업
        recmmRegiPup() {
			this.$.popup('/mem/MEM001P05')
				.then(res => {
					if(res) {
						this.regiRecmmder(res.recmmderHpNo);
					}else {
                        history.replaceState({}, null, location.pathname);
                    }
				});
        },

        regiRecmmder(recmmderHpNo) {
            this.$.httpPost('/api/mem/updateMberInfo', {mberInfo: {recmmderHpNo, mberSeq: this.$store.state.userInfo.mberSeq}})
                .then(res => {
                    if(res.data.resultCode == "000"){
                        alert("추천인 등록이 완료되었습니다.");
                        history.replaceState({}, null, location.pathname);
                    }else {
                        alert(res.data.message);
                    }
                })
                .catch(err => {
                    alert(err.response.data.error_description);
                });
        },

	},
};
</script>